module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBoldItalic.0fc816cb.ttf";